<template>
  <div class="element-tab">
    <slot />
  </div>
</template>
<script>
export default {

}
</script>
